/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel, PublicClientApplication } from "@azure/msal-browser";
import Config from "./config";

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfigORG = {
  auth: {
    clientId: "df67ac26-3cc1-4a28-be10-ae538694fb8d",
    authority:
      "https://login.microsoftonline.com/facb74c5-4332-46a0-ba5f-ba96e47aa26e",
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "localStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            if (Config.log) {
              console.error(message);
            }
            return;
          case LogLevel.Info:
            if (Config.log) {
              console.info(message);
            }
            return;
          case LogLevel.Verbose:
            if (Config.log) {
              console.debug(message);
            }
            return;
          case LogLevel.Warning:
            if (Config.log) {
              console.warn(message);
            }
            return;
        }
      },
    },
  },
};

export const msalConfigB2C = {
  auth: {
    // clientId: "9556fb3a-18be-474d-aece-226e3a6e5063", // DEV, TESTING, BETA
    clientId: "7e4228c3-18f1-427a-ad6c-b794b009d965", //PRODUCTION
    // authority: "https://testEuro24.b2clogin.com/testEuro24.onmicrosoft.com/B2C_1_userflow24",
    authority: "https://eurolandb2corganization.b2clogin.com/eurolandb2corganization.onmicrosoft.com/B2C_1_EurSingInOnlyPolicyId",
    knownAuthorities: ["https://eurolandb2corganization.b2clogin.com"], // Mark your B2C tenant's domain as trusted.
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "localStorage", // This configures where yo`1ur cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            if (Config.log) {
              console.error(message);
            }
            return;
          case LogLevel.Info:
            if (Config.log) {
              console.info(message);
            }
            return;
          case LogLevel.Verbose:
            if (Config.log) {
              console.debug(message);
            }
            return;
          case LogLevel.Warning:
            if (Config.log) {
              console.warn(message);
            }
            return;
        }
      },
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequestORG = {
  scopes: ["api://966eb96a-1b3a-47fb-9a76-ee688fbf37c5/Api.Read"],
};
export const loginRequestB2C = {
  // scopes: ["api://cc3a69c1-626f-45ef-bca1-8e5d0044e9bf/Api.Read"]
  prompt: "select_account",
  scopes: [    
    "openid",
    "profile",
    "offline_access",
    // "https://testEuro24.onmicrosoft.com/85643223-28fa-498c-affc-f254a696eefb/api.read",
    // "https://eurolandb2corganization.onmicrosoft.com/9556fb3a-18be-474d-aece-226e3a6e5063/b2c.api.read.react", // DEV, TESTING, BETA
    "https://eurolandb2corganization.onmicrosoft.com/7e4228c3-18f1-427a-ad6c-b794b009d965/b2c.api.read.orion.ui" //PRODUCTION
  ],
};
/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};

const msalInstanceORG = new PublicClientApplication(msalConfigORG);
const msalInstanceB2C = new PublicClientApplication(msalConfigB2C);

export { msalInstanceORG, msalInstanceB2C };
